import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth';

interface LogoutButtonProps {
  variant?: 'default' | 'ghost' | 'outline';
  showIcon?: boolean;
  showText?: boolean;
  className?: string;
}

/**
 * LogoutButton component for the Partner Bridge UI.
 *
 * FR-001b: Clears JWT token from localStorage and redirects to login page.
 * FR-001c: Redirects to login page upon logout.
 */
export function LogoutButton({
  variant = 'ghost',
  showIcon = true,
  showText = true,
  className,
}: LogoutButtonProps): JSX.Element {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = (): void => {
    // Clear token and redirect to login
    logout();
    void navigate('/login', { replace: true });
  };

  return (
    <Button
      variant={variant}
      onClick={handleLogout}
      className={className}
      data-testid="logout-btn"
    >
      {showIcon && <LogOut className="h-4 w-4" />}
      {showText && <span className={showIcon ? 'ml-2' : ''}>Logout</span>}
    </Button>
  );
}
